import { Attention } from '@peacecover/icon';
import { useToast } from '@chakra-ui/react';
import ToastContentBox from '../../components/toast/ToastContentBox';

export const useWarningToast = () => {
  const toast = useToast();

  const showWarningToast = (
    position: 'top' | 'bottom' = 'bottom',
    message = '',
    isDarkMode = false
  ) => {
    toast({
      duration: 2000,
      position: position,
      render: () => (
        <ToastContentBox
          startElement={
            <Attention
              width={20}
              height={20}
              gradientStops={[
                { offset: '0%', color: '#FF45A9' },
                { offset: '100%', color: '#FF6A6A' }
              ]}
            />
          }
          position={position}
          message={message}
          isDarkMode={isDarkMode}
        />
      )
    });
  };
  return showWarningToast;
};
